import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Mtrwl } from '../entity/Mtrwl-angular';

export interface MtrwlData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     WL001: string;            // 單號 20 ** 建檔時間 20220601-150245755    WL002: string;            // 序號 4     WL003: number;            // 排序碼 4     WL004: string;            // text內文 1000     WL005: string;            // 日期 8     WL006: Date;            // Date 0     WL007: string;            // 主旨 100     WL008: string;            // 星號 1 [DEF:"N"]    WL009: string;            // 來源單號 100     WL010: string;            // 股票代號 10 WL001=STKMA.MA001 MTRWD.WD015='03'    WL011: string;            // tag 1 [DEF:"N"]    WL012: string;            // 格式 1 [DEF:"T"]  T:text H:html M:markdown    WL013: string;            // md內文 0     WL014: string;            // 大分類 10 -> WD015  JCKMG ON MG001='MTRWD' AND MG002=MTRWD.WD015    WL015: number;            // 時數 6.1 }


@Injectable({
  providedIn: 'root'
})
export class MtrwlServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = 'WL001=WD001' ; 
    this.defaultItem = new Mtrwl(); 
    this.entityType.type = EntityType.detail;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        WL001 : '單號' , WL002 : '序號' , WL003 : '排序碼' , WL004 : 'text內文' , WL005 : '日期' , WL006 : 'Date' , WL007 : '主旨' , WL008 : '星號' , WL009 : '來源單號' , WL010 : '股票代號' , WL011 : 'tag' , WL012 : '格式' , WL013 : 'md內文' , WL014 : '大分類' , WL015 : '時數'  }; 

    this.fieldNames = 'WL001,WL002,WL003,WL004,WL005,WL006,WL007,WL008,WL009,WL010,WL011,WL012,WL013,WL014,WL015' ;
    this.fieldLengths = {WL001 : 20 ,WL002 : 4 ,WL003 : 4 ,WL004 : 1000 ,WL005 : 8 ,WL006 : 0 ,WL007 : 100 ,WL008 : 1 ,WL009 : 100 ,WL010 : 10 ,WL011 : 1 ,WL012 : 1 ,WL013 : 0 ,WL014 : 10 ,WL015 : 6.1 } ;
    this.columnDefs = [
      { field: "WL008", headerName: "星號",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WL002", headerName: "序號",headerTooltip: "",width:102,cellDataType: "text", },
      { field: "WL003", headerName: "排序碼",headerTooltip: "",width:102,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WL005", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WL004", headerName: "text內文",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "WL013", headerName: "md內文",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WL007", headerName: "主旨",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WL011", headerName: "tag",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WL012", headerName: "格式",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "WL010", headerName: "股票代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WL009", headerName: "來源單號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WL006", headerName: "Date",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "WL001", headerName: "單號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "WL014", headerName: "大分類",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WL015", headerName: "時數",headerTooltip: "",width:119,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'MTRWL' ;
    this.isSys =false; 
    this.sqlSelect = `SELECT *  FROM MTRWL` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY WL001,WL003 DESC,WL002` ;
    this.keyFields = ['WL001','WL002'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['WL001','WL002'];
    this.seqField = 'WL002' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Mtrwl): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Mtrwl): Promise<Mtrwl> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

